export default "__VITE_ASSET__DVfMi5xZ__"